<div id="login-form">
  <div *ngIf="notValidConfirmation">
    <div class="alert alert-danger" style="font-size: 13px;">Sorry, this confirmation page is not valid. Either it has
      expired or your new email address has already been confirmed. In case of any trouble, please contact us.
    </div>
  </div>
  <div *ngIf="newEmailConfirmed">
    <div class="alert alert-success" style="font-size: 13px;">Your email has been changed successfully.</div>
  </div>
  <div class="login-form-actions text-center">
    <div class="login-form-actions text-center">
      <div>
        <p-button label="login" routerLink="/" styleClass="btn btn-primary btn-sm text-right"></p-button>
      </div>
    </div>
  </div>
</div>
